module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/characters/sara_giggle-f59c43c85e15482d7fe0fc5dcac1de28.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/characters/sara_giggle.png
// module id = 2266
// module chunks = 2